module.exports = __webpack_public_path__ + "img/action-btn-3.ac88e3f7.png";